import React , {useState, useContext} from 'react';
// import emailjs from 'emailjs-com';
import emailjs from '@emailjs/browser';
import { LanguageContext } from '../../context/LanguageContext';
import translations from '../../translations';

const Result = () => {
    const { language } = useContext(LanguageContext);
    const t = translations[language];
    return (
        <p className="success-message">{t.contact.form.success}</p>
    )
}
function ContactForm({props}) {
    const { language } = useContext(LanguageContext);
    const t = translations[language];
    const [ result,showresult ] = useState(false);
    const [email,setEmail]= useState('')
    const[name,setName] = useState('')
    const[phoneNumber, setPhoneNumber]= useState('')
    const [subject,setSubject] = useState('')
    const [message,setMessage]= useState('')
    const sendEmail = (e) => {
        e.preventDefault();
        let params = {
            email,
            name,
            phoneNumber,
            subject,
            message
        }
        emailjs
        .send(
            'service_g1tscxv', 
            'template_ovmcf48', 
            params, 
            'user_6vxcnuagWVUfrPKzTihBU'
        )
        .then((result) => {
            console.log(result.text);
            }, 
            (error) => {
                console.log(error.text);
            }
        );
        e.target.reset();
        showresult(true);
    };

    setTimeout(() => {
        showresult(false);
    }, 5000);

    return (
        <form action="" onSubmit={sendEmail}>
            <div className="rn-form-group">
                <input
                type="text"
                name="from-name"
                placeholder={t.contact.form.fields.name}
                onChange={e=>(setName(e.target.value))}
                required
                />
            </div>
            <div className="rn-form-group">
                <input
                type="email"
                name="email"
                placeholder={t.contact.form.fields.email}
                onChange={e=>(setEmail(e.target.value))}
                required
                />
            </div>
            <div className="rn-form-group">
                <input
                type="text"
                name="phone"
                placeholder={t.contact.form.fields.phone}
                onChange={e=>(setPhoneNumber(e.target.value))}
                required
                />
            </div>

            <div className="rn-form-group">
                <input
                type="text"
                name="subject"
                placeholder={t.contact.form.fields.subject}
                onChange={e=>(setSubject(e.target.value))}

                required
                />
            </div>
            <div className="rn-form-group">
                <textarea
                name="message"
                placeholder={t.contact.form.fields.message}
                onChange={e=>(setMessage(e.target.value))}
                required
                >
                </textarea>
            </div>
            <div className="rn-form-group">
                <button className="rn-button-style--2 btn-solid" type="submit" value="submit" name="submit" id="mc-embedded-subscribe">{t.contact.form.submit}</button>
            </div>
            <div className="rn-form-group">
                {result ? <Result /> : null}
            </div>
        </form>
    )
}
export default ContactForm;
